import { Outlet, RouteObject } from 'react-router'
import { lazy } from 'react'
import { AppraisalResponseDetailsProvider } from '@/pages/appraisal/hooks/useAppraisalResponseDetails.ts'

const AppraisalEventListPage = lazy(() => import('@/pages/appraisal/appraisal-event-list.tsx'))
const CreateAppraisalEventPage = lazy(() => import('@/pages/appraisal/create-appraisal-event.tsx'))
const AppraisalEventDetailsPage = lazy(() => import('@/pages/appraisal/appraisal-event-details.tsx'))
const AppraisalResponseDetailsPage = lazy(() => import('@/pages/appraisal/appraisal-response-details.tsx'))
const OwnAppraisalResponseListPage = lazy(() => import('@/pages/appraisal/own-appraisal-response-list.tsx'))
const AppraisalGoalListPage = lazy(() => import('@/pages/appraisal/appraisal-goal-list.tsx'))
const CreateAppraisalGoalPage = lazy(() => import('@/pages/appraisal/create-appraisal-goal.tsx'))
const AppraisalGoalDetailsPage = lazy(() => import('@/pages/appraisal/appraisal-goal-details.tsx'))


export const appraisalRoutes: RouteObject = {
  path: 'appraisal',
  element: <Outlet />,
  children: [
    { path: 'events', element: <AppraisalEventListPage /> },
    { path: 'events/create', element: <CreateAppraisalEventPage /> },
    { path: 'events/:appraisalEventId', element: <AppraisalEventDetailsPage /> },
    { path: 'goals', element: <AppraisalGoalListPage /> },
    { path: 'goals/create', element: <CreateAppraisalGoalPage /> },
    { path: 'goals/:goalId', element: <AppraisalGoalDetailsPage /> },
  ],
}

export const userAppraisalRoutes: RouteObject = {
  path: 'appraisal',
  element: <Outlet />,
  children: [
    { index: true, element: <OwnAppraisalResponseListPage /> },
    {
      path: 'responses/:responseId',
      element: <AppraisalResponseDetailsProvider><AppraisalResponseDetailsPage /></AppraisalResponseDetailsProvider>,
    },
  ],
}